export default (str) => {
  const hash = str.split("").map((c) => c.charCodeAt(0))
    .reduce((s, v) => s + v, 0);
  const excluded = String(hash).split("")
    .reduce((s, v) => s + Number(v), 0) % 3;

  const pattern = {
    0: `rgb(0, x, y)`,
    1: "rgb(x, 0, y)",
    2: "rgb(x, y, 0",
  }[excluded];

  const x = hash % 220;
  // eslint-disable-next-line newline-per-chained-call
  const y = Number(String(hash).split("").reverse().join("")) % 220;

  return pattern.replace("x", x).replace("y", y);
}